import React from 'react';
import './AlertBanner.css';

interface AlertBannerProps {
  message: string;
  description: string;
  actionLabel: string;
  onAction?: () => void;
  variant?: 'warning' | 'error';
}

const AlertBanner: React.FC<AlertBannerProps> = ({
  message,
  description,
  actionLabel,
  onAction,
  variant = 'warning',
}) => {
  return (
    <div className={`alert-banner alert-${variant}`}>
      <div className="alert-content">
        <div className="alert-text">
          <div className="alert-message">{message}</div>
          <div className="alert-description">{description}</div>
        </div>
        <button className="alert-action-btn" onClick={onAction}>
          {actionLabel}
        </button>
      </div>
    </div>
  );
};

export default AlertBanner;

